import {EditOutlined, PlusOutlined} from '@ant-design/icons'
import {Button, Flex} from 'antd'
import {CampaignSelector} from 'common/components/reloadable/CampaignSelector'
import {FC} from 'react'


interface Props {
    value?: number
    onChange?: (value: any) => void
    onEdit: () => void
    onNew: () => void
    advertiserId?: number
    disabled: boolean
}

export const CampaignSelectPanel: FC<Props> = (
    {value, onChange, onEdit, onNew, advertiserId, disabled}: Props
) => <Flex>
    <CampaignSelector value={value} onChange={onChange} placeholder="Select campaign" style={{flex: 1}}
                      advertiserId={advertiserId}
                      disabled={!advertiserId || disabled}/>
    <Button disabled={!value || disabled} style={{marginLeft: 4}} onClick={onEdit}><EditOutlined/></Button>
    <Button type="primary" style={{marginLeft: 24}} onClick={onNew} ghost
            disabled={!advertiserId || disabled}><PlusOutlined/>New
        Campaign</Button>
</Flex>